import {
  mutationOptions,
  MutationOptions,
  QueryCache,
  QueryClient,
  QueryOptions,
  queryOptions,
} from '@tanstack/react-query';

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error) => {
      console.error('Query error:', error);
    },
  }),
  defaultOptions: {
    queries: {
      retry: false,
      structuralSharing: false,
      staleTime: 10000,
      gcTime: 10000,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retryDelay: 10000,
    },
  },
});

export const queryFactory = <T>({
  key,
  queryFn,
  options,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  key: any[];
  queryFn: () => Promise<T>;
  options?: QueryOptions;
}) => {
  return queryOptions({
    queryKey: key,
    queryFn,
    ...options,
  });
};

export const mutationFactory = <T>({
  mutationFn,
  options,
}: {
  mutationFn: () => Promise<T>;
  options?: MutationOptions;
}) => {
  return mutationOptions({
    mutationFn,
    ...options,
  });
};

export const queryBuilder = <T>(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  queryOptions: QueryOptions & { queryKey: any[]; queryFn: () => Promise<T> },
) => {
  return queryClient
    .getQueryCache()
    .build(queryClient, {
      queryFn: queryOptions.queryFn,
      queryKey: queryOptions.queryKey,
    })
    .fetch();
};
